<template>
	<div class="nav center-width">
		<div class="logo-wrap">
			<img class="logo-img" src="../../assets/images/common/new_logo.png"/>
			<span class="logo-text">上海商晟通云网络科技有限公司</span>
		</div>
		<ul class="nav-list">
			<li><a :class="{active:isIndex}" href="index.html">首页</a></li>
			<li><a :class="{active:isSpot}" href="spot.html">现货资源</a></li>
			<li><a :class="{active:isArticle}" href="article.html">全部文章</a></li>
		</ul>
		<div class="search right">
			<input @keyup.enter="searchSpots" type="text" placeholder="品种/规格" v-model="keyWord"/>
			<button @click="searchSpots">搜索</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
		  return {
		  	isIndex:false,
		  	isArticle:false,
		  	isSpot:false,
				isDownload:false,
				keyWord: '',
      };
		},
		props:['s_content'],
		created(){
			this.setActive();
			this.keyWord = this.s_content
		},
		watch: {
			s_content: function(val){
				console.info(val)
				this.keyWord = val
			}
		},
		methods: {
			setActive(){
				var url = window.location.href;
				this.isArticle = url.match('article')?true:false;
				this.isSpot = url.match('spot')?true:false;
				//首页可能没有后缀
				this.isIndex = (url.match('index')||!url.match('html'))?true:false;
				this.isDownload = url.match('download')?true:false;
			},
			searchSpots(){
				if(this.isSpot){//如果在现货页面搜索，用子组件通信
					this.$emit('searchGoods',this.keyWord);
				}else{//如果在别的页面 则跳转带参查询
					if(this.keyWord){
//					open(`spot.html?query=${this.keyWord}`);
						location.href=`spot.html?query=${this.keyWord}`;
					}else{
						location.href = 'spot.html';
					}
				}
			},
			goDownload(){
				if(this.isDownload){
					this.$emit('alertTips');
				}else {
					open('download.html');
				}
			}
		},
		components:{
		}
	}
</script>

<style lang="stylus" scoped>
.nav {
	height: 50px;
	background-color: #fff;
	.logo-wrap {
		display: inline-block;
		line-height: 50px;
	}
	.logo-img {
		width: 94px;
		vertical-align: sub;
	}
	.logo-text {
		font-weight: bold;
		font-size: 20px;
		margin-left: 5px;
	}
	.nav-list {
		display: inline-block;
		/*vertical-align: middle;*/
		margin-left: 40px;
		li {
			font-size: 18px;
			color: #000;
			display: inline-block;
			width: 120px;
			font-family: "arial black";
			text-align: center;
		}
	}
}
</style>


// WEBPACK FOOTER //
// nav.vue?09dc7f49